import React, { Component } from "react";

const formatDetailDate = (value) => {
  if (!value || value === "0001-01-01T00:00:00") return "-";
  return new Date(value).toLocaleString("tr-TR");
};

export default class DemandDetail extends Component {
  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown = (event) => {
    if (event.key === "Escape") {
      this.props.onClose();
    }
  };

  renderField = (label, value, options = {}) => (
    <div className={`t-memberInfo-field${options.full ? " t-demandDetailModal-fieldFull" : ""}`}>
      <span className="t-memberInfo-fieldLabel">{label}</span>
      <span
        className={`t-memberInfo-fieldValue${
          options.multiline ? " t-demandDetailModal-valueMultiline" : ""
        }`}
      >
        {value || "-"}
      </span>
    </div>
  );

  render() {
    const { demand, onClose } = this.props;
    const hasResponse = demand?.musteriCevap != null && demand?.musteriCevap !== "";

    return (
      <>
        <div
          className="modal fade show t-demandDetailModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby={`demandDetailTitle${demand.talepNo}`}
          aria-modal="true"
          style={{ display: "block", zIndex: 1055 }}
        >
          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
            <div className="modal-content t-guarantorModal-content border-0">
              <div className="t-guarantorModal-header">
                <div className="t-guarantorModal-header-content">
                  <div className="t-guarantorModal-icon">
                    <i className="t-icon-search1" aria-hidden="true" />
                  </div>
                  <div>
                    <h5 className="t-guarantorModal-title" id={`demandDetailTitle${demand.talepNo}`}>
                      Talep Detayı
                    </h5>
                    <p className="t-guarantorModal-subtitle">
                      Talep No: <strong>{demand?.talepNo || "-"}</strong>
                    </p>
                  </div>
                </div>
                <button
                  type="button"
                  className="t-guarantorModal-close"
                  onClick={onClose}
                  aria-label="Kapat"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className="t-guarantorModal-body t-demandDetailModal-body">
                <div className="t-memberInfo-grid t-demandDetailModal-grid">
                  {this.renderField("Talep Durumu", demand?.durumu)}
                  {this.renderField("Açılma Tarihi", formatDetailDate(demand?.acilisTarihi))}
                  {this.renderField("Kapanma Tarihi", formatDetailDate(demand?.kapanisTarihi))}
                  {this.renderField("Konu", demand?.konu, { full: true })}
                  {this.renderField("Açıklama", demand?.aciklama, { full: true, multiline: true })}
                  {hasResponse &&
                    this.renderField("Cevap", demand?.musteriCevap, {
                      full: true,
                      multiline: true,
                    })}
                </div>
              </div>

              <div className="t-guarantorModal-footer">
                <button
                  type="button"
                  className="t-memberInfo-btn t-memberInfo-btn--secondary"
                  onClick={onClose}
                >
                  <span>Kapat</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal-backdrop fade show t-demandDetailModal-backdrop"
          style={{ zIndex: 1050 }}
          onClick={onClose}
          aria-hidden="true"
        />
      </>
    );
  }
}
